// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Loading } from 'element-ui';
export default {
  install (Vue, options) {
    Vue.prototype.statementToPdf = function ({ title, html_arr, cb }) {
      let loadingInstance = Loading.service({
        lock: true,
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.6)',
        text: '导出中...'
      });
      var image_url = [];
      let canvas = document.createElement("canvas");
      function html2CanvasLun (html_name, cannvas_cb) {
        var shareContent = document.getElementById(html_name); //需要截图的包裹的（原生的）DOM 对象
        var width = shareContent.offsetWidth; //获取dom 宽度
        var height = shareContent.offsetHeight; //获取dom 高度
        canvas.width = width * 2;
        canvas.height = height * 2;
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";
        let context = canvas.getContext("2d");
        context.scale(2, 2);
        var opts = {
          canvas: canvas,
          scale: 1, // 添加的scale 参数
          logging: true, //日志开关
          useOverflow: true,
          backgroundColor: '#ffffff',
        };
        html2Canvas(shareContent, opts).then(res => {
          var contentWidth = res.width
          var contentHeight = res.height
          // // 一页pdf显示html页面生成的canvas高度;
          // var pageHeight = contentWidth / 592.28 * 841.89
          // // 未生成pdf的html页面高度
          // var leftHeight = contentHeight
          // // pdf页面偏移
          // var position = 0
          // html页面生成的canvas在pdf中图片的宽高（a4纸的尺寸[595.28,841.89]）
          var imgWidth = 592.28
          var imgHeight = 600 / contentWidth * contentHeight
          var pageData = res.toDataURL('image/jpeg', 0.3)
          image_url.push({ imgWidth: imgWidth, imgHeight: imgHeight, pageData: pageData })
          cannvas_cb ? cannvas_cb() : ''
        })
      }
      // 轮询页面导出为pdf
      function htmlTpPdf (index) {
        let item = html_arr[index]
        loadingInstance.setText(`共 ${html_arr.length} 页，正在导出第 ${index + 1} 页，请耐心等待...`)
        if (index == html_arr.length - 1) {
          html2CanvasLun(item, () => {//最后一页
            const PDF = new jsPDF('p', 'pt', 'a4')
            image_url.forEach((item, index) => {
              PDF.addImage(item.pageData, 'JPEG', -2, 0, item.imgWidth, item.imgHeight)
              if (index != image_url.length - 1) {
                PDF.addPage()
              }
            })
            PDF.save(title + '.pdf')
            loadingInstance.close()
            cb ? cb() : ''
          })
        } else {
          html2CanvasLun(item, () => {
            htmlTpPdf(index + 1)
          })
        }
      }
      htmlTpPdf(0)
      //     html_arr.forEach((item,index) => {
      //       if(index == html_arr.length - 1){
      //         html2CanvasLun(item,()=>{
      //           const PDF = new jsPDF('p', 'pt', 'a4')
      //           image_url.forEach((item,index)=>{
      //             PDF.addImage(item.pageData, 'JPEG', -2, 0, item.imgWidth, item.imgHeight)
      //             if(index!=image_url.length-1){
      //               PDF.addPage()
      //             }
      //           })
      //           PDF.save(title + '.pdf')
      //           loadingInstance.close()
      //           cb?cb():''
      //         })
      //       }else{
      //         html2CanvasLun(item)
      //       }
      //     });
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/statementToPdf.js